
export default () => ({
	searchActive: false,
	searchQuery: '',
	searchResults: [],
	searchResultsTotal: 0,
	isResultsOpen: false,
	isHits: false,
	searchAlgolia(e) {
		e.target.value = '';
		const queries = [
			{
				indexName: 'products',
				query: this.searchQuery,
			},
			{
				indexName: 'projects',
				query: this.searchQuery,
			},
			{
				indexName: 'people',
				query: this.searchQuery,
			},
			{
				indexName: 'pages',
				query: this.searchQuery,
			},
		];
		client.multipleQueries(queries).then((res) => {
			this.searchActive = true;
			this.searchResultsTotal = 0;
			// for each res.results push hits to searchResults
			this.searchResults = [];
			res.results.forEach((result) => {
				let res = {};
				res.indexName = result.index;
				res.hits = result.hits;
				res.totalHits = result.nbHits;
				this.searchResultsTotal += result.nbHits;
				this.searchResults.push(res);
			});
			this.isResultsOpen = true;
			if (this.searchResults[0].hits.length > 0 || this.searchResults[1].hits.length > 0 || this.searchResults[2].hits.length > 0) {
				this.isHits = true;
			}
		}
		);
	},
	resetSearch() {
		this.searchActive = false;
		this.searchQuery = '';
		this.searchResults = [];
		this.isResultsOpen = false;
		this.isHits = false;
		document.body.style.overflow = 'auto';
	},
	exitSearch() {
		this.resetSearch()
	},
	init() {
		console.log('search init');
	}
})
